import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton
} from 'baseui/modal';

import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';

import debug from 'utils/debug';

const { METHOD } = debug('c:ModalWindows:SourceEditor');

export default (props) => {
  METHOD('SourceEditor', props);

  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState('{}');
  const [title, setTitle] = useState('Info');
  const [config, setConfig] = useState({});

  useEffect(() => {
    METHOD('Update', { props });

    window.openSourceEditor = (value, opts) => {
      METHOD('openSourceEditor', { value, opts });
      const options = opts || {};

      const source =
        typeof value === 'string' ? value : JSON.stringify(value, '\n', 4);
      METHOD('content', { content });

      setTitle(options.title || 'Source');
      setContent(source);
      setConfig(options);
      setIsOpen(true);
    };
    window.closeSourceEditor = () => {
      METHOD('closeSourceEditor', {
        isOpen,
        title,
        content,
        config
      });
      setIsOpen(false);
    };
    return () => {
      METHOD('Cleanup');
      window.closeSourceEditor = null;
    };
  });

  function onClose() {
    METHOD('onClonse', { isOpen, title, content, config });

    setIsOpen(false);
  }

  function onSave() {
    METHOD('onSave', { isOpen, title, content, config });

    if (config.onSave) {
      setConfig({});
      config.onSave(content);
    }

    setIsOpen(false);
  }

  return (
    <React.Fragment>
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        overrides={{
          Dialog: {
            style: {
              width: '900px',
              height: '80vh',
              display: 'flex',
              flexDirection: 'column'
            }
          }
        }}
      >
        <ModalHeader>{title}</ModalHeader>
        <ModalBody style={{ flex: '1 1 0' }}>
          <AceEditor
            mode='json'
            theme='github'
            value={content}
            defaultValue={content}
            onChange={setContent}
            name='ace'
            width='100%'
            height='100%'
            setOptions={{
              useWorker: false
            }}
            editorProps={{ $blockScrolling: true }}
          />
        </ModalBody>
        <ModalFooter>
          <ModalButton onClick={onClose}>Close</ModalButton>
          {!config.readOnly && config.onSave && (
            <ModalButton onClick={onSave}>Save</ModalButton>
          )}
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};
